module.exports = __webpack_public_path__ + "static/media/36.740ccc68.jpeg";